


















import { Component, Vue } from 'vue-property-decorator';
import UserNotificationForm from '@/components/forms/UserNotificationForm.vue';

@Component({
    components: {
        UserNotificationForm
    }
})
export default class NotificationAdd extends Vue {
}
